module.exports = __webpack_public_path__ + "static/media/poppins-400.891f6ba4.ttf";